// extracted by mini-css-extract-plugin
export default {"imageWrapper":"Success_imageWrapper__pnw1L","card":"Success_card__CR10W","buttons":"Success_buttons__CSXNl"};